import Box from "@mui/material/Box";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { UseUpload } from "src/context/UploadProductContext";

const SellerSelected = ({
  isSmallerThanTablet = false,
  setDataSearch = () => {},
  dataSearch = {},
  isFullWidth = false,
}) => {
  const { masterdata } = UseUpload();
  const { seller_data } = masterdata;

  const sellerOptions = seller_data.map((sel) => {
    return {
      ...sel,
      userRoles: [1],
      value: sel.seller._id,
      label: sel.seller.company_name,
    };
  });

  const selectedSellerIds = dataSearch?.seller?.split(",");

  const selectedSellers = sellerOptions.filter((item) =>
    selectedSellerIds.includes(item.value),
  );
  return (
    <Box
      sx={{
        display: isSmallerThanTablet ? "none" : "flex",
        width: "100%",
        minWidth: "140px",
        maxWidth: isFullWidth ? "100%" : "200px",
      }}
    >
      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        limitTags={1}
        options={sellerOptions}
        value={selectedSellers}
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        onChange={(e, value) =>
          setDataSearch({
            ...dataSearch,
            seller: value.map((mp) => mp.value).join(","),
            page: 0,
          })
        }
        isOptionEqualToValue={(option, value) => option.label === value.label}
        renderOption={(props, option, { selected, index }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={`${key}-${index}`} {...optionProps}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />

              {option.label}
            </li>
          );
        }}
        renderInput={(params) => <TextField {...params} label="ร้านค้า" />}
        sx={{ width: "100%" }}
        componentsProps={{
          popper: { style: { width: "300px" } },
        }}
      />
    </Box>
  );
};

export default SellerSelected;
